import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
    return (
        <div className="mainContent">
            <h4>404 Page Not Found</h4>
            <Link to="/"> Go back to homepage </Link>
        </div>
    );
}

export default NotFoundPage;
